import {imageMap} from "../../../../images/imageMap.ts";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";
import {WhatRouter} from "../../../../components/help/CommonQuestions.tsx";

export default function WifiSkiftNavnKodeArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Hvis du ønsker at ændre dit navn og kodeord på dit wifi, så hjælper vi dig gerne med det.
                            Brug følgende guide &ndash; det er nemt og hurtigt!
                        </p>
                    </div>
                </div>

                <div className={'article'}>
                    <h2>
                        Vælg din router for at finde hjælp
                    </h2>
                    <div className={'choose-router-container'}>
                        <a href={'#zyxel'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_ex33}
                                    alt={'Billede af vores Zyxel EX/VMG router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel EX33/EX36/VMG
                            </span>
                        </a>
                        <a href={'#zyxel'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_ex56}
                                    alt={'Billede af vores Zyxel EX5601 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel EX5601
                            </span>
                        </a>
                        <a href={'#sagemcom'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.sagemcom_3890}
                                    alt={'Billede af vores Sagemcom 3890 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Sagemcom 3890/3896
                            </span>
                        </a>
                        <a href={'#zyxel-nr5307'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_nr5307}
                                    alt={'Billede af vores Zyxel NR5307 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel NR5307
                            </span>
                        </a>
                        <a href={'#huawei-h158'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.huawei_h158}
                                    alt={'Billede af vores Huawei H158 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Huawei H158
                            </span>
                        </a>
                        <a href={'#not-sure'} className="not-sure">
                            <span className={'text'}>
                                Ved du ikke hvilken router du har?
                            </span>
                        </a>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'zyxel'} className={'id-anchor--help'}/>
                <div className={"article"}>
                    <h2>Zyxel EX33, EX36, EX56 og VMG</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Du kan skifte dit wifi-navn og kode i <Link to={Routing.Selfcare.Internet} target={'_blank'}>Mit Hiper</Link> under fanen <strong>Internet</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Rul ned til <strong>Dit wifi-navn og -kode</strong> og vælg <strong>Redigér</strong>.
                            </p>
                        </li>
                        <img
                            className={'br1 box-shadow'}
                            src={imageMap.help.network.selfcareInternetWifiLogin}
                            alt="Billede af wifi-login sektionen i Mit Hiper."
                        />
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'sagemcom'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>Sagemcom 3890/3896</h2>
                        <div className={'text-box text-box--gray'}>
                            <p>
                                Du kan kun ændre wifi-navn og kode på <a href="https://mitwifi.dk/" target="_blank">mitwifi.dk</a> &ndash;{' '}
                                <strong>ikke</strong> ved at logge på routeren.
                            </p>
                        </div>
                        <ol className="list list--number list--image">
                            <li>
                                <p>
                                    Åbn <a href="https://mitwifi.dk/" target="_blank">mitwifi.dk</a>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.mitwifi.mitwifiLogin}
                                alt="Grafik som illustrerer Log-in siden på mitwifi.dk."
                            />
                            <li>
                                <p>
                                    Log ind med det kontonummer og aktiveringskode, som står under menupunktet <Link to={Routing.Selfcare.Account}>Profil</Link> i Mit&nbsp;Hiper ved <strong>Login til mitwifi.dk</strong>.
                                </p>
                            </li>
                            <img
                                className="box-shadow paragraph"
                                src={imageMap.help.network.selfcareProfileMitwifi}
                                alt="Grafik som viser login oplysningerne til mitwifi.dk inde i Mit Hiper."
                            />
                            <li>
                                <p>
                                    Vælg <strong>Rediger</strong> i sektionen <strong>Dit Trådløse Netværk</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.mitwifi.mitwifiOversight}
                                alt="Grafik som viser oversigten af siden på mitwifi.dk."
                            />
                            <li>
                                <p>
                                    Tryk på <strong>Avanceret opsætning</strong> under <strong>Gem</strong>-knappen.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.mitwifi.mitwifiRediger}
                                alt="Grafik af &ldquo;Rediger&rdquo; pop-up på mitwifi.dk."
                            />
                            <li>
                                <p>
                                    Indstil navn og/eller kode.
                                </p>
                                <p>
                                    Kriterier til dit wifi-navn:
                                </p>
                                <ul className="list list--bullet list--compact">
                                    <li><p>Mellem 4-20 tegn.</p></li>
                                    <li><p>Kan kun indeholde A-Z og 0-9.</p></li>
                                    <li><p>Æ, ø og å samt mellemrum er ikke muligt.</p></li>
                                </ul>
                                <p>
                                    <strong>Vi anbefaler</strong> at du skriver &ldquo;_5G&rdquo; til sidst i dit 5 GHz-netværk, så du kan kende forskel på dit 2,4 GHz- og 5 GHz-netværk.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.mitwifi.mitwifiAvanceret}
                                alt="Grafik af &ldquo;Avanceret opsætning&rdquo; på mitwifi.dk."
                            />
                            <li>
                                <p>
                                    Vælg <strong>Gem</strong> og herefter <strong>Bekræft</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.mitwifi.mitwifiBekraeft}
                                alt="Grafik af &ldquo;Bekræft&rdquo; knappen på mitwifi.dk."
                            />
                            <li>
                                <p>
                                    Når nedtællingen er slut, er dine ændringer klar!
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'zyxel-nr5307'} className={'id-anchor--help'}/>
                <div className={"article"}>
                    <h2>Zyxel NR5307</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Sørg for at du er forbundet til routerens netværk via wifi eller netværkskabel.
                            </p>
                        </li>
                        <li>
                            <p>
                                Indtast &ldquo;192.168.1.1&rdquo; i din browser.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiLogin}
                            alt="Grafik som illustrerer Log-in siden på en Zyxel router."
                        />
                        <li>
                            <p>
                                Log ind med oplysningerne herunder.
                            </p>
                            <ul className="list list--bullet list--compact">
                                <li>
                                    <p>
                                        <strong>Username:</strong>{' '}
                                        Skriv <strong>admin</strong>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <strong>Password:</strong>{' '}
                                        Står ved <strong>Password</strong> bag på din router.
                                    </p>
                                </li>
                            </ul>
                            <img
                                className={'no-br'}
                                src={imageMap.help.network.gui.zyxel_nr5307.zyxelNr5307RouterLogin}
                                alt="Grafik som illustrerer kode og password på router."
                            />
                        </li>
                        <li>
                            <p>
                                Klik på <strong>{">"}</strong> i <strong>WiFi&nbsp;Settings</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiHomeWifi}
                            alt="Grafik af GUI&rsquo;en på en Zyxel router med fokus på &ldquo;WiFi Settings&rdquo;."
                        />
                        <li>
                            <p>
                                Vælg, om du vil lave ændringer på dit 2,4 GHz- eller 5 GHz-netværk.
                                Ønsker du at ændre begge, skal du gøre det på ét af gangen.
                            </p>
                            <ul className="list list--bullet list--compact">
                                <li>
                                    <p>
                                        Du kan ændre navnet under <strong>WiFi&nbsp;Name</strong>.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Du kan ændre koden ved at fjerne fluebenet fra <strong>Random&nbsp;Password</strong>.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiWifi}
                            alt="Grafik som illustrerer siden hvor man kan ændre navn og kode på wifi."
                        />
                        <li>
                            <p>
                                Tryk <strong>Save</strong> i bunden.
                            </p>
                        </li>
                        <li>
                            <p>
                                Nu kan du logge på dit wifi med dit nye login!
                            </p>
                        </li>
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'huawei-h158'} className={'id-anchor--help'}/>
                <div className="article">
                    <h2>Huawei H158</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Sørg for at du er forbundet til routerens netværk via wifi eller netværkskabel.
                            </p>
                        </li>
                        <li>
                            <p>
                                Åbn en browser og indtast &ldquo;192.168.8.1&rdquo; i adressefeltet.
                            </p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>
                                        Hvis du har ændret routerens IP-adresse, skal du indtaste den i stedet.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                Log ind med det <strong>Password</strong>, som står under din router.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.gui_login}
                            alt="Grafik der viser login informationen på Huawei H158 routeren."
                        />
                        <li>
                            <p>
                                Vælg <strong>Avanceret</strong> i den blå menu.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.home_advanced}
                            alt="Billede der viser top menuen i Huawei H158 routerens GUI."
                        />
                        <li>
                            <p>
                                Tryk på blyant-knappen ud for det netværk, du vil ændre.
                            </p>
                            <p>
                                Du har to wifi netværk: Dit 2,4&nbsp;GHz som hedder <strong>H158-381_XXXX</strong> og dit 5&nbsp;GHz som hedder <strong>H158-381_XXXX_5G</strong>.
                            </p>
                            <p>
                                Du kan læse om <Link to={'/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser'}>forskellen på 2,4- og 5&nbsp;GHz her</Link>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.wifi}
                            alt="Billede der viser wifi menuen i Huawei H158 routerens GUI."
                        />
                        <li>
                            <p>
                                Når du har indtastet det nye navn og kode, skal du trykke på <strong>Gem</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.wifi_change}
                            alt="Billede der viser ændring af wifi navn og kode i Huawei H158 routerens GUI."
                        />
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>{WhatRouter.question}</h2>
                        {WhatRouter.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "navn-og-kode-til-wifi",
                        "name": "Hvor ser jeg mit navn og kode til wifi?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4- og 5 GHz"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    }
                ]}
            />
        </>
    )
}
